import React from 'react'

class ViewErrorBoundary extends React.Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  reset = () => this.setState({ error: null })

  render() {
    const { error } = this.state
    if (error) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <p style={{ color: '#d32f2f', marginBottom: 16 }}>
            {error.message || 'Something went wrong'}
          </p>
          <button type="button" onClick={this.reset}>
            Retry
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ViewErrorBoundary
